module.exports = __webpack_public_path__ + "static/media/ic_01_easyofuse.07a7a077.svg";